import React from "react";
import {
  Table,
} from "reactstrap";
import moment from 'moment';
import CheckinReportModel from "../../../../utils/models/CheckinReportModel";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function GuestsList({
  guestsList = [],
  loading = false,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Programação</th>
              <th>Data do Check-in</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={5} />
            ) : (
              guestsList.map((s, i) => renderRow(i, s))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(index = 0, checkin = CheckinReportModel()) {
    return (
      <tr key={index}>
        <td>{checkin.id}</td>
        <td>{checkin.nome}</td>
        <td>{checkin.email}</td>
        <td>{checkin.tituloProgramacao}</td>
        <td>{checkin.dataRegistro}</td>
      </tr>
    )
  }
}
